/* Marcottestyle — Landelijke Keuken pillar
   Scroll reveal + FAQ accordion. Safe to include multiple times: guarded. */
(function () {
  if (window.__mcsLkInit) return;
  window.__mcsLkInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mcs-lk__reveal:not([data-lk-seen])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-lk-seen', ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          e.target.setAttribute('data-lk-seen', '');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq(root) {
    var btns = (root || document).querySelectorAll('.mcs-lk__faq-q:not([data-lk-bound])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-lk-bound', '');
      var item = btn.closest('.mcs-lk__faq-item');
      // Sync initial open state (first item defaults to expanded).
      if (item && btn.getAttribute('aria-expanded') === 'true') item.classList.add('is-open');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (item) item.classList.toggle('is-open', !open);
      });
    });
  }

  function boot(root) { initReveal(root); initFaq(root); }

  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });

  // Shopify theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
